<template>
  <div class="badge absolute -left-1 top-2 drop-shadow z-50">
    <div v-bind="$attrs" class="pl-2 leading-5 font-semibold italic flex items-center">
      <slot name="icon" />
      <div>
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
}
</script>
